/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        //Shrink Header
        // When the user scrolls down 50px from the top of the document, resize the header's font size

        // ANIMATION
        AOS.init({
        duration: 500,
        });

        $(document).on("scroll", function(){
          if ($(document).scrollTop() > 200){
            $("header#masthead").addClass("small");
          } else {
            $("header#masthead").removeClass("small");
          }
        });

        $('.dropdown').hover(function() {
      $(this).find('.dropdown-menu').first().stop(true, true).delay(250).slideDown();

      }, function() {
      $(this).find('.dropdown-menu').first().stop(true, true).delay(100).slideUp();

      });
      $('.navbar .dropdown > a').click(function(){
        location.href = this.href;
        });

        $("[data-trigger]").on("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        var offcanvas_id =  $(this).attr('data-trigger');
        $(offcanvas_id).toggleClass("show");
        $('body').toggleClass("offcanvas-active");
        $(".screen-overlay").toggleClass("show");
    });

    $(".btn-close, .screen-overlay").click(function(e){
        $(".screen-overlay").removeClass("show");
        $(".mobile-offcanvas").removeClass("show");
        $("body").removeClass("offcanvas-active");
    });

      //*==========OWL CAROUSEL==========*/

        // Carousels ----------//
        $(".owl-carousel.home").owlCarousel({
          // Navigation
          nav : true,
          // loop: ( $('.owl-carousel .items').length > 5 ),
          loop: true,
          dots: false,
          autoplay: true,
          autoplayTimeout:8000,
          responsiveClass:true,
          lazyLoad: true,
	        navText: ['<span class="fas fa-chevron-left fa-2x"></span>','<span class="fas fa-chevron-right fa-2x"></span>'],
          responsive : {
              // breakpoint from 0 up
              0 : {
                  items : 1,
                  margin : 3
              },
              // breakpoint from 480 up
              480 : {
                items : 1,
                margin : 10
              },
              // breakpoint from 768 up
              768 : {
                items : 1,
                margin : 10
              },
              // breakpoint from 992 up
              992 : {
                items : 1,
                margin : 10
              }
          }
        });
        $(".owl-carousel.timeline").owlCarousel({
        items:1,
        loop:true,
        dots: false,
        center:true,
        margin:20,
        smartSpeed:750,
        URLhashListener:true,
        autoplayHoverPause:true,
        startPosition: 'URLHash'
        });
},

      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },


    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
  }
};
//*==============INSERT ADS INTO CALENDAR================*//


  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
